module.exports = __webpack_public_path__ + "img/1-3-p2.3fe82767.svg";